module.exports = __webpack_public_path__ + "img/H5.6c35a91e.png";